import type { ConfigurationItem, Translate } from '../types';

const NAVIGATION_BADGE_NO_BADGE = 'navigation_badge_no_badge';

export const searchDropdown: ConfigurationItem = (t: Translate) => {
  return [
    [
      'SearchDropdownItem',
      {
        item: {
          key: 'members',
          icon: { $component: 'IconSearch' },
          href: '/search/members',
          title: t('SEARCH_DROPDOWN_MEMBERS'),
          tracking: {
            sc_o: 'navigation_search_member_search',
            sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
          },
        },
      },
    ],
    [
      'SearchDropdownItem',
      {
        item: {
          key: 'jobs',
          icon: { $component: 'IconSearch' },
          href: '/jobs/search',
          title: t('SEARCH_DROPDOWN_JOBS'),
          tracking: {
            sc_o: 'navigation_search_job_search',
            sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
          },
        },
      },
    ],
    [
      'SearchDropdownItem',
      {
        item: {
          key: 'companies',
          icon: { $component: 'IconSearch' },
          href: '/search/companies',
          title: t('SEARCH_DROPDOWN_COMPANIES'),
          tracking: {
            sc_o: 'navigation_search_companies_search',
            sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
          },
        },
      },
    ],
    [
      'SearchDropdownItem',
      {
        item: {
          key: 'news',
          icon: { $component: 'IconSearch' },
          href: '/search/news',
          title: t('SEARCH_DROPDOWN_NEWS'),
          tracking: {
            sc_o: 'navigation_search_news_content_search',
            sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
          },
        },
      },
    ],
  ];
};
